import { useQuery } from '@tanstack/react-query';
import { Navigate, useSearchParams } from 'react-router';
import { api } from '../api/client';

// /wallet cu (mot danh sach ca nap lan rut) da tach thanh Nap tien va Rut tien (owner 2026-10-02):
// chuyen sang trang dung chieu, giu cac bo loc khac. Lien ket theo ma lenh khong ghi chieu thi hoi danh sach
// mot lan: bo loc ref con khop chuoi con (ghi chu lenh cu...), nen lenh co ma / ma chuyen / ma giao dich dung
// bang ref quyet dinh; khong co thi cac lenh tim thay cung mot chieu; con lai (khong thay, lan, loi) ve Nap tien.
export const WALLET_PATH = { DEPOSIT: '/wallet/deposits', WITHDRAW: '/wallet/withdrawals' } as const;

type Hang = { id: string; direction: string; noiDung?: string | null; maChuyen?: string | null };

function chieuCua(items: Hang[], ref: string): string | undefined {
  const k = ref.toLowerCase();
  const dung = items.find((r) => [r.id, r.noiDung, r.maChuyen].some((x) => x && x.toLowerCase() === k));
  if (dung) return dung.direction;
  const cac = new Set(items.map((r) => r.direction));
  return cac.size === 1 ? [...cac][0] : undefined;
}

export function WalletRedirect() {
  const [params] = useSearchParams();
  const dir = params.get('direction');
  const ref = params.get('ref') ?? '';
  const hoi = dir !== 'DEPOSIT' && dir !== 'WITHDRAW' && ref.trim() !== '';
  const q = useQuery({
    queryKey: ['wallet-redirect', ref],
    queryFn: () => api.get<{ items: Hang[] }>('/api/admin/wallet', { ref, page: 1, pageSize: 200 }),
    enabled: hoi,
    retry: false,
  });
  if (hoi && q.isLoading) return <div className="page"><p className="muted">Đang mở lệnh...</p></div>;
  const chieu = dir === 'WITHDRAW' || (hoi && chieuCua(q.data?.items ?? [], ref.trim()) === 'WITHDRAW') ? 'WITHDRAW' : 'DEPOSIT';
  const rest = new URLSearchParams(params);
  rest.delete('direction');
  const s = rest.toString();
  return <Navigate replace to={WALLET_PATH[chieu] + (s ? '?' + s : '')} />;
}
